import Cookies from 'js-cookie'
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";

if ($('.js-trigger-age-gateway-popup').length) {
    Fancybox.bind('.js-trigger-age-gateway-popup', {
        closeButton: false,
        dragToClose: false,
        click: false,
    });

    setTimeout(() => {
        //Trigger age gateway popup
        document.querySelector('.js-trigger-age-gateway-popup').click();
    }, "1000");
}

$(document).ready(function () {
    const ageConfirmedCookie = "_db_ageconfirmed";
    const underageCookie = "_db_underage";

    $(".js-agegateway-yes").click(function () {
        const expiration = $(".js-agegateway").data("expiration");
        if (expiration) {
            Cookies.set(ageConfirmedCookie, true, { expires: expiration });
        }
        else {
            //set session cookie
            Cookies.set(ageConfirmedCookie, true);
        }
        Fancybox.close();
    })

    $(".js-agegateway-no").click(function () {
        Cookies.set(underageCookie, true);
        Fancybox.close();
        location.reload();
    })
});
